
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/check-email",
      function () {
        return require("private-next-pages/check-email.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/check-email"])
      });
    }
  